module.exports = __webpack_public_path__ + "static/media/step-card-active.e3a3e0b2.svg";